import Utils from "../../js/helpers/Utils";

class ReceiptPathFactory { 

    constructor(path, userId, sessionId, subscriptionType, orderNo, paymentLogSeq){
        this.path = path;
        this.userId = userId;
        this.sessionId = sessionId;
        this.subscriptionType = subscriptionType;
        this.orderNo = orderNo;
        this.paymentLogSeq = paymentLogSeq;
    }

    get finalPath(){
        let params = [
            { name: 'sessionId', value: this.sessionId },
            { name: 'userId', value: this.userId },
            { name: 'orderNo', value: this.orderNo },
            { name: 'paymentLogSeq', value: this.paymentLogSeq },
            { name: 'subscriptionType', value: this.subscriptionType }
        ];

        return Utils.generateParameters(this.path, params);
    }
}

export default ReceiptPathFactory;
